import React from 'react'
import {Route, Redirect, Switch} from "react-router-dom";
import Login from "../components/auth/Login";
import Register from "../components/auth/Register";
import AccountActivationScreen from "../components/auth/AccountActivationScreen";
import LandingPage from "../screens/LandingPage";

const FarmerRoutes = () => {
    return (
        <Switch>
            <Route path="/login" component={Login} exact/>
            <Route path="/register" component={Register} exact/>
            <Route path="/account_activation/:token" component={AccountActivationScreen} exact/>
            <Route component={LandingPage}/>
        </Switch>
    )
}

export default FarmerRoutes